import { urlSchema } from "@repo/components/src/utils/yup";
import * as yup from "yup";

export const connectWooCommerceSchema = yup.object({
  host: urlSchema.required(
    "Ingrese la página web de su tienda de WooCommerce.",
  ),
});

export type ConnectWooCommerceSchemaType = yup.InferType<
  typeof connectWooCommerceSchema
>;
